/**
 * Number formatting helper. It returns a filter that will take a large number and return it's abbreviated form. So it
 * will do the following conversions:
 *      - 1,783 => '1.8K'
 *      - 22,000 => '22K'
 *      - 43,213,546 => '43.2M'
 *      - 5,770,000,000 => '5.7B'
 *      - 1222333444555 => '1.2T'
 *  There is a limit to how high a number it will convert. After 999T, it will continue showing the number as multiples
 *  of a trillion (2.3 quadrillion => 2,300T).
 */

/**
 * Return a filter function
 *
 * @param {Function} numeral - Numeral.js dependency
 * @returns {Function} - number formatting filter
 */
export default function getFormatter(numeral) {
    /**
     * Returns a shorter format of a large number
     *
     * @param {number} inputVal - number to be formatted
     * @returns {string} - formatted output string
     */
    return (inputVal) => numeral(inputVal).format('0,0.0a').toUpperCase();
}
